import { IceServer, ParsedOffer } from './types';

function addTrailingSlash(input: string): string {
  if (input.endsWith('/')) {
    return input;
  } else {
    return input + '/';
  }
}

export const buildKVDSServerUrl = (url: string, groupName: string, streamName: string) => {
  return `${addTrailingSlash(url)}${addTrailingSlash(groupName)}${addTrailingSlash(streamName)}`;
};

// TODO check on this fn
const unquoteCredential = (v: string): any => JSON.parse(`"${v}"`);

export const linkToIceServers = (links: string | null): IceServer[] => {
  return links !== null
    ? links.split(', ').map((link: string) => {
        const m = link.match(
          /^<(.+?)>; rel="ice-server"(; username="(.*?)"; credential="(.*?)"; credential-type="password")?/i
        );
        const ret: any = {
          urls: [m![1]],
        };

        if (m![3] !== undefined) {
          ret.username = unquoteCredential(m![3]);
          ret.credential = unquoteCredential(m![4]);
          ret.credentialType = 'password';
        }

        return ret;
      })
    : [];
};

export const parseOffer = (offer: string | undefined): ParsedOffer => {
  const ret: ParsedOffer = {
    iceUfrag: '',
    icePwd: '',
    medias: [],
  };

  for (const line of (offer ?? '').split('\r\n')) {
    if (line.startsWith('m=')) {
      ret.medias.push(line.slice('m='.length));
    } else if (ret.iceUfrag === '' && line.startsWith('a=ice-ufrag:')) {
      ret.iceUfrag = line.slice('a=ice-ufrag:'.length);
    } else if (ret.icePwd === '' && line.startsWith('a=ice-pwd:')) {
      ret.icePwd = line.slice('a=ice-pwd:'.length);
    }
  }

  return ret;
};

export const enableStereoOpus = (section: string): string => {
  let opusPayloadFormat = '';
  let lines = section.split('\r\n');

  for (let i = 0; i < lines.length; i++) {
    if (lines[i].startsWith('a=rtpmap:') && lines[i].toLowerCase().includes('opus/')) {
      opusPayloadFormat = lines[i].slice('a=rtpmap:'.length).split(' ')[0];
      break;
    }
  }

  if (opusPayloadFormat === '') {
    return section;
  }

  for (let i = 0; i < lines.length; i++) {
    if (lines[i].startsWith('a=fmtp:' + opusPayloadFormat + ' ')) {
      if (!lines[i].includes('stereo')) {
        lines[i] += ';stereo=1';
      }
      if (!lines[i].includes('sprop-stereo')) {
        lines[i] += ';sprop-stereo=1';
      }
    }
  }

  return lines.join('\r\n');
};

export const editOffer = (offer: RTCSessionDescriptionInit): void => {
  const sections = (offer.sdp ?? '').split('m=');

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i];
    if (section.startsWith('audio')) {
      sections[i] = enableStereoOpus(section);
    }
  }

  offer.sdp = sections.join('m=');
};

export const generateSdpFragment = (
  offerData: { iceUfrag: string; icePwd: string; medias: string[] },
  candidates: any[]
): string => {
  const candidatesByMedia: { [key: number]: any[] } = {};
  for (const candidate of candidates) {
    const mid = candidate.sdpMLineIndex;
    if (candidatesByMedia[mid] === undefined) {
      candidatesByMedia[mid] = [];
    }
    candidatesByMedia[mid].push(candidate);
  }

  let frag = 'a=ice-ufrag:' + offerData.iceUfrag + '\r\na=ice-pwd:' + offerData.icePwd + '\r\n';

  let mid = 0;

  for (const media of offerData.medias) {
    if (candidatesByMedia[mid] !== undefined) {
      frag += 'm=' + media + '\r\na=mid:' + mid + '\r\n';

      for (const candidate of candidatesByMedia[mid]) {
        frag += 'a=' + candidate.candidate + '\r\n';
      }
    }
    mid++;
  }

  return frag;
};
